import { render, staticRenderFns } from "./ResetPW.vue?vue&type=template&id=5b00fd5d&scoped=true"
import script from "./ResetPW.vue?vue&type=script&lang=js"
export * from "./ResetPW.vue?vue&type=script&lang=js"
import style0 from "./ResetPW.vue?vue&type=style&index=0&id=5b00fd5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00fd5d",
  null
  
)

export default component.exports